module.exports = __webpack_public_path__ + "app/community/modal-cga-import-GDMmLcOt.html";